(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mwc-partner-program"]) return;
  try {
    
(() => {
function init(root) {
 if (!root || root.dataset.initialized) return;
 root.dataset.initialized='true';
 const tabs=[...root.querySelectorAll('[role="tab"]')];
 const text=root.dataset;
 function choose(i){
  const mode=i===0?'application':'contact';
  tabs.forEach((t,n)=>{t.setAttribute('aria-selected',String(i===n));t.tabIndex=i===n?0:-1;});
  root.querySelector('#form-panel').setAttribute('aria-labelledby',tabs[i].id);
  root.querySelectorAll('.application-fields').forEach(el=>{el.hidden=i===1;el.querySelectorAll('input,select').forEach(input=>{input.disabled=i===1;});});
  root.querySelector('#form-title').textContent=text[mode+'Title'];
  root.querySelector('#form-intro').textContent=text[mode+'Intro'];
  root.querySelector('#message-label').textContent=text[mode+'Message'];
  root.querySelector('#submit-button').firstChild.textContent=text[mode+'Button']+' ';
  root.querySelector('#mwc-partner-request-type').value=text[mode+'Type'];
 }
 tabs.forEach((tab,i)=>{
  tab.addEventListener('click',()=>choose(i));
  tab.addEventListener('keydown',event=>{if(['ArrowLeft','ArrowRight','Home','End'].includes(event.key)){event.preventDefault();const n=event.key==='Home'?0:event.key==='End'?1:1-i;choose(n);tabs[n].focus();}});
 });
 const status=root.querySelector('.mwc-form-status');
 if(status){status.focus();status.scrollIntoView({block:'center'});}
}
function start(){init(document.getElementById('mwc-partner-page'));}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
document.addEventListener('shopify:section:load',start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mwc-product-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mwc-product-editorial')) {
  class MwcProductEditorial extends HTMLElement {
    connectedCallback() {
      const main = document.querySelector('.product-information');
      if (main) main.id = 'mwc-product-selection';
      if (!window.mwcSizeGuideBound) {
        window.mwcSizeGuideBound = true;
        document.addEventListener('click', event => {
          const control = event.target.closest('[data-mwc-size-guide]');
          if (!control) return;
          const trigger = document.querySelector('.product-details .mwc-scale-trigger, .product-details .mwc-triptych-trigger');
          trigger?.click();
        });
      }
      const root = this.dataset.rootUrl || '/';
      if (root !== '/') {
        this.querySelectorAll('.mwc-editorial-description a[href]').forEach(link => {
          try {
            const url = new URL(link.href, location.href);
            if (url.origin !== location.origin) return;
            if (/^\/(products|collections|pages|blogs|policies|cart)(\/|$)/.test(url.pathname)) {
              url.pathname = root.replace(/\/$/, '') + url.pathname;
              link.href = url.pathname + url.search + url.hash;
            }
          } catch {}
        });
      }
    }
  }
  customElements.define('mwc-product-editorial', MwcProductEditorial);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["signup-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('private-collector-popup')) {
    customElements.define('private-collector-popup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');
        this.success = this.querySelector('.mwc-collector__success');
        this.status = this.querySelector('.mwc-collector__status');
        this.closeButtons = this.querySelectorAll('.mwc-collector__close, .mwc-collector__continue');
        this.dismissKey = 'mwc_collector_popup_dismissed';
        this.joinedKey = 'mwc_collector_joined';
        this.hasShown = false;

        if (this.dataset.pageType === 'cart' || this.isSuppressed()) return;

        this.showHandler = () => this.show();
        this.scrollHandler = () => {
          const available = document.documentElement.scrollHeight - window.innerHeight;
          const progress = available > 0 ? window.scrollY / available * 100 : 100;
          if (progress >= Number(this.dataset.scroll || 35)) this.show();
        };
        this.exitHandler = (event) => {
          if (this.dataset.exitIntent === 'true' && event.clientY <= 0 && !event.relatedTarget) this.show();
        };

        this.timer = window.setTimeout(this.showHandler, Number(this.dataset.delay || 12) * 1000);
        window.addEventListener('scroll', this.scrollHandler, { passive: true });
        document.addEventListener('mouseout', this.exitHandler);

        this.closeButtons.forEach((button) => button.addEventListener('click', () => this.dismiss()));
        this.dialog?.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.dismiss();
        });
        this.form?.addEventListener('submit', (event) => this.submit(event));
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        window.removeEventListener('scroll', this.scrollHandler);
        document.removeEventListener('mouseout', this.exitHandler);
      }

      isSuppressed() {
        if (localStorage.getItem(this.joinedKey) === 'true') return true;
        const dismissed = Number(localStorage.getItem(this.dismissKey) || 0);
        const duration = Number(this.dataset.dismissDays || 14) * 86400000;
        return dismissed > 0 && Date.now() - dismissed < duration;
      }

      show() {
        if (this.hasShown || this.isSuppressed() || !this.dialog) return;
        this.hasShown = true;
        window.clearTimeout(this.timer);
        window.removeEventListener('scroll', this.scrollHandler);
        document.removeEventListener('mouseout', this.exitHandler);
        this.dialog.showModal();
      }

      dismiss() {
        localStorage.setItem(this.dismissKey, String(Date.now()));
        this.dialog?.close();
      }

      async submit(event) {
        event.preventDefault();
        const button = this.form?.querySelector('button[type="submit"]');
        if (!this.form || !button) return;
        button.disabled = true;
        this.status.hidden = true;

        try {
          const response = await fetch(this.form.action, {
            method: 'POST',
            body: new FormData(this.form),
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
          if (!response.ok) throw new Error('Subscription failed');
          localStorage.setItem(this.joinedKey, 'true');
          this.form.hidden = true;
          this.success.hidden = false;
          this.success.focus();
        } catch (error) {
          this.status.textContent = this.dataset.errorMessage;
          this.status.hidden = false;
          button.disabled = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
